module.exports = __webpack_public_path__ + "static/WhoWeAre-Mobile-5ea6237d090ca1aec5107f369609600e.png";